import { lazy } from 'react'

const ForgotPasswordPage = lazy(() => import('./ForgotPasswordPage'))
const LoginOtpPage = lazy(() => import('./LoginOtpPage'))
const LoginPage = lazy(() => import('./LoginPage'))

export { ForgotPasswordPage, LoginOtpPage, LoginPage }
